export const EXAMPLE_ACTION_TYPE = {
  UPDATE_COUNT: 'update_count', // 计数
  ADD_SENSORS: 'add_sensors',
  UPDATE_MSGLIST: 'update_msgList', // 消息列表
  UNSHIFT_MSGLIST: 'unshift_msgList' // 消息列表
}

export const SENSORS_ACTION_TYPE = {
  // 更新唤醒App的数据
  UPDATE_OPEN_APP_DATA: 'update_open_app_data',
  CLEAN_OPEN_APP_DATA: 'clean_open_app_data',
}
